// Relative "time ago" from a date-only ISO string (YYYY-MM-DD), day granularity.
export function timeAgo(iso) {
  if (!iso) return "";
  const parts = String(iso).split("-").map(Number);
  const then = new Date(parts[0], (parts[1] || 1) - 1, parts[2] || 1);
  if (isNaN(then.getTime())) return "";
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const days = Math.round((startOfToday - then) / 86400000);
  if (days <= 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 7) return `${days} days ago`;
  if (days < 14) return "1 week ago";
  if (days < 30) return `${Math.floor(days / 7)} weeks ago`;
  if (days < 60) return "1 month ago";
  if (days < 365) return `${Math.floor(days / 30)} months ago`;
  const years = Math.floor(days / 365);
  return years === 1 ? "1 year ago" : `${years} years ago`;
}
